import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from '../components/Button';
import { useInputChanged } from '../context/InputChangedContext';
import { logMessage } from '../hooks/logger';

export function useGoToStep() {
    const navigate = useNavigate();
    const { inputChanged, validDataInputs, saveFn } = useInputChanged();

    const [showConfirm, setShowConfirm] = useState(false);
    const [showIncomplete, setShowIncomplete] = useState(false);
    const [nextStep, setNextStep] = useState(null);

    const handleCloseConfirm = () => setShowConfirm(false);
    const handleCloseIncomplete = () => setShowIncomplete(false);

    const handleConfirm = async () => {
        if (typeof saveFn === "function") {
            try {
                await saveFn(); 
            } catch (err) {
                console.error("Error en saveFn:", err);
                logMessage('Error', '⚠ Error del servidor (4xx,5xx provincia):', err.response.status);
                return; 
            }
        }
        if (nextStep) {
            navigate(`/${nextStep}`);
        }
        setShowConfirm(false);
    };

    const goToStep = (e, step) => {
        e.preventDefault();
        setNextStep(step);

        if (!validDataInputs) {
            setShowIncomplete(true);
            return;
        }

        if (inputChanged) {
            setShowConfirm(true);
            return;
        }

        navigate(`/${step}`);
    };

    const ConfirmModal = () => (
        <Modal show={showConfirm} onHide={handleCloseConfirm} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmar navegación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Cambios detectados en el formulario. ¿Seguro que desea continuar sin guardar?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseConfirm}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleConfirm}>
                    Guardar Datos
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const IncompleteModal = () => (
        <Modal show={showIncomplete} onHide={handleCloseIncomplete} centered>
            <Modal.Header closeButton>
                <Modal.Title>Campos incompletos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Debes completar todos los campos obligatorios antes de continuar.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseIncomplete}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );

    return { goToStep, ConfirmModal, IncompleteModal };
}
